import React from "react";
import LegalLayout from "./LegalLayout";

const RefundPolicy = () => (
  <LegalLayout title="Refund Policy" lastUpdated="11 July 2026">
    <p>
      Operated by <strong>Pingme Software Design</strong> ("Ping", "we", "us"),
      registered in the United Arab Emirates. Contact:{" "}
      <a href="mailto:tariq@pingme.ae">tariq@pingme.ae</a> ·{" "}
      <a href="https://www.pingme.ae">www.pingme.ae</a>. Applies across all Ping
      products: Ping Stitch, Ping Laundry, Ping Drive, and Ping Paw.
    </p>

    <h2>1. Overview</h2>
    <p>
      This policy explains when refunds are and are not available for Ping
      subscriptions across all products (Ping Stitch, Ping Laundry, Ping Drive,
      Ping Paw).
    </p>

    <h2>2. Free trials</h2>
    <p>
      Where a free trial is offered, you will not be charged during the trial
      period. You may cancel at any time before the trial ends to avoid being
      charged. If you do not cancel, your subscription and billing begin at the
      end of the trial.
    </p>

    <h2>3. Subscription fees</h2>
    <p>
      Subscription fees are billed in advance for each billing cycle (for
      example, monthly). Because access to the platform is provided immediately
      and continuously, subscription fees are generally non-refundable once a
      billing cycle has begun, except as set out below or as required by
      applicable UAE law.
    </p>

    <h2>4. Cancellations</h2>
    <p>
      You may cancel your subscription at any time. Cancellation stops future
      billing; it does not retroactively refund the current cycle. You will
      retain access until the end of the paid period.
    </p>

    <h2>5. Exceptions — when we may refund</h2>
    <p>
      We may, at our discretion, provide a full or partial refund where:
    </p>
    <ul>
      <li>you were charged in error;</li>
      <li>
        a proven technical fault on our side prevented you from using the core
        service for a significant period and we were unable to resolve it; or
      </li>
      <li>a refund is required by applicable law.</li>
    </ul>

    <h2>6. What is not refundable</h2>
    <p>The following are non-refundable:</p>
    <ul>
      <li>
        WhatsApp/Meta per-message fees and other third-party charges already
        incurred;
      </li>
      <li>amounts for message-sending or campaigns already delivered; and</li>
      <li>partial billing periods after cancellation.</li>
    </ul>

    <h2>7. How to request a refund</h2>
    <p>
      Email <a href="mailto:tariq@pingme.ae">tariq@pingme.ae</a> with your
      account details and the reason for your request within 14 days of the
      charge. We aim to respond within a reasonable period and will assess
      eligible requests in good faith.
    </p>

    <h2>8. Changes</h2>
    <p>
      We may update this policy. The latest version is available at{" "}
      <a href="https://www.pingme.ae">www.pingme.ae</a>.
    </p>

    <h2>9. Contact</h2>
    <p>
      <a href="mailto:tariq@pingme.ae">tariq@pingme.ae</a>.
    </p>
  </LegalLayout>
);

export default RefundPolicy;
